import { render } from "./operaciones-canales.vue?vue&type=template&id=6935baf2"
import script from "./operaciones-canales.vue?vue&type=script&lang=js"
export * from "./operaciones-canales.vue?vue&type=script&lang=js"

import "./operaciones-canales.vue?vue&type=style&index=0&id=6935baf2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__